// extracted by mini-css-extract-plugin
export default {"privacy-policy":"PrivacyPolicy_privacy-policy__Wj5cf","contacts":"PrivacyPolicy_contacts__x2d2N","header":"PrivacyPolicy_header__PewBR"};